import makeStyles from '@mui/styles/makeStyles';
import {useDispatch} from 'react-redux';
import * as React from 'react';
import {useEffect} from 'react';
import {setSnackbar} from '../../../store/reducers/globals';
import {Button, InputLabel, MenuItem, OutlinedInput, Select, TableCell, TableRow, Typography} from '@mui/material';
import * as _get from 'lodash/get';
import {ArrowIconHL7, ErrorIconHL7} from '../../../components/icons/icons';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import {styled} from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import * as _ from 'lodash';

export const ColumnTypes = {
    TEXT: 1,
    ACTIONS: 2,
    CHEACKBOX: 3,
    FUNC: 4
};

const useTableStyles = makeStyles((theme) => ({
        typeSelect: {
            width: 150,
            height: 50,
            marginLeft: '15px',
        },
        typeSelectItem: {
            '&:hover': {
                backgroundColor: '#448FFF',
                color: 'white',
            },
        },
        agyleButton: {
            background: '#448FFF',
        },
        errorContainer: {
            cursor: 'pointer',
            backgroundColor: '#FFECEC',
            maxWidth: '100%',
            borderRadius: '7px',
            marginBottom: '10px',
        },
        errorIconOuter: {
            minWidth: '85px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '10px',
            marginRight: '10px',
        },
        errorIconInner: {
            height: '40px',
            width: '40px',
            backgroundColor: 'white',
            borderRadius: '50%',
            paddingLeft: '10px',
            paddingTop: '10px',
            boxShadow: '0 0 10px red',
        },
        errorContainerText: {
            marginTop: '20px',
            marginRight: '20px',
            marginBottom: '20px',
            wordBreak: 'initial',
        },
        spaceBetween: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',

        },
        textWithArrow: {
            cursor: 'pointer',
            display: 'flex',
            gap: '5px',
        },
    }),
);

const StyledFormControl = styled(FormControl)(({theme}) => ({
    '&.MuiOutlinedInput-root': {
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
        '&.Mui-focused fieldset': {
            borderColor: '#448FFF',
        },
    },
    // '&.MuiInputBase-input':{
    //     borderRadius: "50%",
    //     '&:focus': {
    //         borderColor: '#448FFF',
    //     }
    // }
}));
export function saveDataToCSV(csv,tableData,haeders) {
    const replacer = (key, value) => (!value ? '' : value); // specify how you want to handle null values here
    const data = tableData.map((row) =>
        haeders.map(function (column) {
            let val = column.csvValueFunc ? column.csvValueFunc(row) : _.get(row,column.value);
            if (_.isObject(val)) {
                val = JSON.stringify(val, replacer);
            }
            if (val && _.isString(val)) {
                val = val.replace(/"/g, "'");
                if (!val.startsWith('"')) {
                    val = `"${val}`;
                }
                if (!val.endsWith('"')) {
                    val = `${val}"`;
                }
            }
            return val;
        }).join(','));
    csv = csv + "\r\n" + data.join('\r\n');
    return csv;
}

function RowMessage(props) {
    const columns = props.columns;
    const row = props.row;
    const classes = useTableStyles();

    const dispatch = useDispatch();

    const [messageVisible, setMessageVisible] = React.useState(false);

    const [selected, setSelected] = React.useState(false);

    const handleAddToSelectRows = (row) => {
        setSelected(!selected);
    };

    useEffect(() => {
        if (props.handleAddRow && selected)
            props.handleAddRow(row);
        if (props.handleRemoveRow && !selected)
            props.handleRemoveRow(row);
    }, [selected]);

    const handleMessageClick = () => {
        setMessageVisible(!messageVisible);
    };

    const checkMessage = (msg, nm) => {
        switch (nm.key) {
            case 'Copy JSON':
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to copy`, severity: 'error'}));
                return nm.props.onClick();

            case 'Show JSON':
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to show`, severity: 'error'}));
                return nm.props.onClick();

            case 'Details':
                return nm.props.onClick();
        }
    };

    return (<React.Fragment>
        {/*<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>*/}
        <TableRow hover role="checkbox" tabIndex={-1} key={row.code + props.rowIndex}>
            {columns.map((column, index) => {
                switch (column.type) {

                    case ColumnTypes.TEXT:
                    case ColumnTypes.FUNC:
                        const value = (column.type ==  ColumnTypes.FUNC) ?  column.valueFunc(row) : _get(row, column.value);
                        return (
                            <TableCell key={props.rowIndex + index + 'text'} align={column.align}>
                                {column.format
                                    ? column.format(value)
                                    : value}
                                {column.withMessage &&
                                    <div
                                        className={classes.textWithArrow}
                                        style={{color: row.errorMessage ? '#FF6868' : '#448FFF'}}
                                        onClick={() => {
                                            if (row.send && row.send.length > 0 && row.send[row.send.length - 1].hl7message) {
                                                handleMessageClick();
                                            } else if (row.message) {
                                                handleMessageClick();
                                            }
                                        }}
                                    >
                                        <Typography variant="body2" gutterBottom>
                                            Message
                                        </Typography>
                                        <ArrowIconHL7
                                            color={row.errorMessage ? '#FF6868' : '#448FFF'}
                                            sx={{fontSize: 20}}
                                            open={messageVisible}
                                        />
                                    </div>
                                }
                            </TableCell>
                        );

                    case ColumnTypes.ACTIONS:
                        let buttons = [];
                        column.actionList.forEach((action) => {
                            buttons.push(<Button key={action.buttonLabel}
                                                 onClick={() => action.callback(row)}>{action.buttonLabel}</Button>);
                        });

                        return (
                            <TableCell key={props.rowIndex + 'buttons'} align={column.align}>
                                <StyledFormControl className={classes.typeSelect}>
                                    <InputLabel>Select action</InputLabel>
                                    <Select
                                        input={<OutlinedInput/>}
                                    >
                                        {buttons.map((name) => {
                                            return (
                                                <MenuItem
                                                    className={classes.typeSelectItem}
                                                    key={name.key}
                                                    onClick={() => checkMessage(row.message, name)}
                                                    value="Select action"
                                                >
                                                    {name.key}
                                                </MenuItem>
                                            );
                                        })
                                        }
                                    </Select>
                                </StyledFormControl>
                            </TableCell>
                        );
                    case ColumnTypes.CHEACKBOX:
                        return (
                            <TableCell key={props.rowIndex + index + 'ch'} align={column.align || 'center'}
                                       sx={{borderLeft: row.errorMessage ? '2px solid red' : ''}}>
                                <Checkbox
                                    onChange={() => {
                                        handleAddToSelectRows(row);
                                    }}
                                    checked={selected}
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}
                                    color={'info'}
                                />
                            </TableCell>
                        );

                }

            })}
        </TableRow>

        {/*TODO*/}
        {/*Make check if other page than this item is on, if yes - make somehow to not render opened messages*/}

        {/*{messageVisible && <TableRow>*/}
        {/*    <TableCell style={{wordBreak: "break-all", paddingBottom: 0, paddingTop: 0 }} colSpan={8}>*/}

        {/*        <div style={{color: "red"}}>{row.errorMessage}</div>*/}
        {/*        <div>Messages</div>*/}
        {/*        {props.messagePath(row)}*/}

        {/*    </TableCell>*/}
        {/*</TableRow>}*/}
        {messageVisible && (
            <TableRow hover key={row._id}>
                <TableCell
                    style={{
                        wordBreak: 'break-all',
                        padding: '10px 40px 10px 50px',
                        borderLeft: row.errorMessage ? '2px solid red' : '',
                    }}
                    colSpan={8}
                    align="justify"
                >
                    {row.errorMessage && (<Grid container direction="row" className={classes.errorContainer}
                                                style={{color: row.error ? 'red' : 'blue'}}>
                        <Grid item xs={1} className={classes.errorIconOuter}>
                            <div className={classes.errorIconInner}>
                                <ErrorIconHL7/>
                            </div>
                        </Grid>
                        <Grid item xs={9} style={{display: 'flex'}}>
                            <Grid item xs={12} className={classes.errorContainerText}>
                                <Typography variant="subtitle2">Error</Typography>
                                <Grid item xs={12}>
                                    <Typography variant="body2" sx={{color: 'black'}}>{row.errorMessage}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>)}
                    <Grid container style={{marginBottom: '10px'}}>
                        <Typography variant="subtitle2" sx={{marginBottom: '10px'}}>Messages</Typography>
                        <Typography variant="body2">
                            {props.messagePath(row)}
                        </Typography>
                    </Grid>
                </TableCell>
            </TableRow>
        )}
    </React.Fragment>);
}

export {
    useTableStyles,
    RowMessage
}